import { usePageContext } from 'application/contexts/PageContext';
import { DynamicModuleFeature } from 'features/Modules';
import { BreadcrumbFeature } from 'features/Modules/Breadcrumb';
import { Main } from 'ui/components/4-habitats/Main';

export const ContentPageFeature: React.FC<Content.ContentPage> = ({ properties }) => {
	const { pageHeader, pageSections } = properties ?? {};
	const pageSectionsTopSpacing = usePageContext().getSettings('pageSectionsTopSpacing');

	return (
		<Main
			header={pageHeader.map((headerModule, index) => (
				<DynamicModuleFeature key={index} contentModule={headerModule} />
			))}
			breadcrumb={<BreadcrumbFeature />}
			renderAsArticle={false}
			contentTopSpacing={pageSectionsTopSpacing?.disableTopSpacing ? false : true}
		>
			{pageSections?.map((sectionModule, index) => (
				<DynamicModuleFeature key={index} contentModule={sectionModule} />
			))}
		</Main>
	);
};
